import styled from 'styled-components';
import { convertToTransientProps, getSpacing } from '../../../../utils/index.js';

const Wrapper = styled.div.withConfig({
    shouldForwardProp: convertToTransientProps(['narrow']),
}) `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: ${(props) => getSpacing(props.narrow ? 's04' : 's00', 's04', 's04')};
  border-top: ${(props) => props.narrow ? `1px solid rgba(0, 0, 0, 0.08)` : 'none'};
`;

export { Wrapper };
